import React, { useEffect } from 'react'
import * as CONSTANTS from "../CONSTANTS";

function OrdersScreen() {

  useEffect(() => {
    document.title = 'Orders | Stephenson Adventures';
  },[]);

  return (
    <div className="standard-ountline"><div className="standard-area">OrdersScreen</div></div>
  )
}

export default OrdersScreen